import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'


import { useCartStore } from '@features/cart/model/useCartStore'
import { useModalStore } from '@features/modal'
import { useAddressStore } from '@features/shipping-methods'

import { ProductCarousel } from '@widgets/product-carousel'


import { Product, useSimilarProductsQuery } from '@shared/generated'
import { useEmitter } from '@shared/lib/emitter'

interface ProductsSimilarProps {
  productId: string;
  title?: string;
}

export default function ProductsSimilar (props: ProductsSimilarProps) {
  const { t: tp } = useTranslation('product')
  const { productId, title } = props
  const { shopId } = useAddressStore()
  const { data, loading } = useSimilarProductsQuery({
    variables: {
      shopId: shopId,
      productId,
    },
  })
  const { removeProduct } = useCartStore()
  const { modals } = useModalStore()
  const { emitter } = useEmitter()

  const SIMILAR_PRODUCTS_MODAL_ACTIVE = useMemo(() => {
    return !!modals.get('productsSimilar')?.isOpen
  }, [ modals ])

  emitter.on('addCartProduct', () => {
    if (SIMILAR_PRODUCTS_MODAL_ACTIVE) {
      removeProduct(productId)
    }
  })

  return (
    <ProductCarousel
      // link={URL_PAGE_CATALOG}
      title={title ?? tp('similar_products')}
      products={data?.similarProducts as Product[]}
      loading={loading}
      listName="Similar Products"
      listId={productId}
    />
  )
}
